<template>
  <div class="space-y-10">
    <div
      v-if="$page.props.features?.operating"
      class="px-4 sm:px-6 lg:px-8"
    >
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-xl font-semibold text-gray-900">
            My Engagements
          </h1>
          <p class="mt-2 text-sm text-gray-700">
            A list of all your guide engagements
          </p>
        </div>
        <button
          class="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-success text-base font-medium text-white hover:bg-success-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-success sm:text-sm"
          @click="showCreateEngagementModal = true"
        >
          Create engagement
        </button>
      </div>
      <div class="mt-8 flex flex-col">
        <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table class="min-w-full divide-y divide-gray-300">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Destination
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Description
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Requests
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      class="relative py-3.5 pl-3 pr-4 sm:pr-6"
                    >
                      <span class="sr-only">View</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                  <tr v-for="engagement in engagements">
                    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6">
                      <place :place="engagement.place" />
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <div class="text-gray-900">
                        {{ engagement.description }}
                      </div>
                      <DatePicker
                        v-model="date"
                        range
                        :partial-range="false"
                      />
                      <div class="text-gray-500">
                        <FormattedTime :date="engagement.starts_at" />
                        -
                        <FormattedTime :date="engagement.ends_at" />
                      </div>
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <div class="flex -space-x-2 overflow-hidden">
                        <span
                          v-for="request in engagement.requests"
                          class="inline-block relative h-8 w-8 rounded-full ring-2 ring-white"
                        >
                          <img
                            class="h-8 w-8 rounded-full"
                            :src="request.guide_profile.user.profile_photo_url"
                            :alt="request.guide_profile.user.name"
                          >
                          <svg
                            v-if="request.offer_made_at !== null"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            class="absolute bottom-0 right-1/2 block h-3 w-3 rounded-full text-green-400 bg-white"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <svg
                            v-else-if="request.declined_at !== null"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            class="absolute bottom-0 right-1/2 block h-3 w-3 rounded-full text-red-500 bg-white"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <svg
                            v-else
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            class="absolute bottom-0 right-1/2 block h-3 w-3 rounded-full text-gray-600 bg-white"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </span>
                        <!--<img v-for="request in engagement.requests" class="inline-block h-8 w-8 rounded-full ring-2 ring-white" :src="request.guide_profile.user.profile_photo_url" :alt="request.guide_profile.user.name">-->
                      </div>
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <span class="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">Active</span>
                    </td>
                    <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                      <Link
                        :href="route('engagements.show', {engagement: engagement.id})"
                        class="text-indigo-600 hover:text-indigo-900"
                      >
                        View<span class="sr-only"> engagement {{ engagement.id }}</span>
                      </Link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <CreateEngagement
        :show="showCreateEngagementModal"
        @close="showCreateEngagementModal = false"
      />
    </div>
    <div
      v-if="$page.props.features?.guiding"
      class="px-4 sm:px-6 lg:px-8"
    >
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-xl font-semibold text-gray-900">
            My Engagement Requests
          </h1>
          <p class="mt-2 text-sm text-gray-700">
            A list of requests for your guiding services
          </p>
        </div>
      </div>
      <div class="mt-8 flex flex-col">
        <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table class="min-w-full divide-y divide-gray-300">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Destination
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Description
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Operator
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      class="relative py-3.5 pl-3 pr-4 sm:pr-6"
                    >
                      <span class="sr-only">View</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                  <tr v-for="request in requests">
                    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6">
                      <div class="flex items-center">
                        <place :place="request.engagement.place" />
                      </div>
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <div class="text-gray-900">
                        {{ request.engagement.description }}
                      </div>
                      <div class="text-gray-500">
                        <FormattedTime :date="request.engagement.starts_at" />
                        -
                        <FormattedTime :date="request.engagement.ends_at" />
                      </div>
                    </td>
                    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6">
                      <div class="flex items-center">
                        <div class="h-10 w-10 flex-shrink-0">
                          <img
                            class="h-10 w-10 rounded-full object-cover"
                            :src="request.engagement.team.photo_url"
                            :alt="request.engagement.user.name"
                          >
                        </div>
                        <div class="ml-4">
                          <div class="font-medium text-gray-900">
                            {{ request.engagement.team.name }}
                          </div>
                          <div class="text-gray-500">
                            {{ request.engagement.user.name }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <span
                        v-if="request.offer && request.offer.booked_at !== null"
                        class="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800"
                      > Booked </span>
                      <span
                        v-else-if="request.offer_made_at !== null"
                        class="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800"
                      > Offer given </span>
                      <span
                        v-else-if="request.declined_at !== null"
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800"
                      > Declined </span>
                      <span
                        v-else-if="request.expired"
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800"
                      > Expired </span>
                      <span
                        v-else
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800"
                      > Pending </span>
                    </td>
                    <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                      <Link
                        :href="route('engagements.requests.show', {engagementRequest: request.id})"
                        class="text-indigo-600 hover:text-indigo-900"
                      >
                        View
                      </Link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!$page.props.features?.guiding && !$page.props.features?.operating">
      You are not a guide nor an operator, so you cannot see any engagements. <br>
      This is chosen when registering your account. <br>
      If you want to become either one of these with your current account, instead of creating another one, please contact us.
    </div>
  </div>
</template>

<script>
import {Link} from '@inertiajs/vue3'
import { ref } from 'vue';
import Place from '../../ComponentsDeprecated/Place.vue';
import CreateEngagement from '@/ComponentsDeprecated/Modal/CreateEngagement';
import HumanReadableTime from '@/ComponentsDeprecated/Time/HumanReadableTime';
import FormattedTime from '@/ComponentsDeprecated/Time/FormattedTime';

export default {
  name: 'Index',
  components: {
    FormattedTime,
    HumanReadableTime,
    Place,
    CreateEngagement,
      Link,
  },
  props: {
    engagements: {
      type: Array,
      required: false,
      default: [],
    },

    requests: {
      type: Array,
      required: false,
      default: [],
    },
  },
  setup() {
    const date = ref();

    return {
      date,
    };
  },
  data() {
    return {
      showCreateEngagementModal: false,
    };
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style scoped>

</style>
